function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0719 0.105469H1.83811C1.55522 0.105469 1.29038 0.175017 1.05078 0.28965L10.4142 9.65304L12.5128 7.63615C12.5128 7.63615 12.513 7.63595 12.513 7.63587C12.5131 7.63579 12.5132 7.6357 12.5132 7.6357L19.8595 0.289813C19.6199 0.175098 19.3549 0.105469 19.0719 0.105469Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7257 1.15625L13.8125 8.06913L20.7255 14.9821C20.8401 14.7425 20.9097 14.4777 20.9097 14.1948V1.94329C20.9097 1.66056 20.8403 1.39577 20.7257 1.15625Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.184181 1.15576C0.0695478 1.39536 0 1.6602 0 1.94309V14.1946C0 14.4773 0.0694661 14.7422 0.184018 14.9817L7.09727 8.06885L0.184181 1.15576Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9465 8.93563L10.8476 10.9528C10.7279 11.0724 10.5712 11.1322 10.4145 11.1322C10.2578 11.1322 10.101 11.0724 9.98141 10.9528L7.96415 8.93555L1.05078 15.8485C1.29042 15.9632 1.55542 16.0328 1.83839 16.0328H19.0722C19.3551 16.0328 19.6199 15.9633 19.8595 15.8486L12.9465 8.93563Z",
  fill: "white"
});

var SvgMailIc = function SvgMailIc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMailIc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail_ic.77a702a2.svg";
export { ForwardRef as ReactComponent };